export type InputSurface = 'touch' | 'keyboard';

/** Détails facultatifs demandés au scoreur en plus du trio joueur/action/qualité. */
export interface CaptureDetailOptions {
  serviceType: boolean;
  attackType: boolean;
  middleBlockerCall: boolean;
  reversal: boolean;
  /** Nombre de bloqueurs face à l'attaque (0 à 3) — saisie clavier uniquement :
   *  en tactile la ligne est toujours proposée. */
  blockersCount: boolean;
  zones: boolean;
}

export interface CaptureOptions extends CaptureDetailOptions {
  /**
   * Panneau vidéo affiché pendant la saisie (VS-16 lot 2). Actif par défaut :
   * sans vidéo associée le panneau n'est de toute façon pas monté, et sur un
   * match en mode vidéo c'est l'affichage attendu.
   */
  videoPanel: boolean;
}

export const DEFAULT_CAPTURE_OPTIONS: CaptureOptions = {
  serviceType: false,
  attackType: false,
  middleBlockerCall: false,
  reversal: false,
  blockersCount: false,
  zones: false,
  videoPanel: true,
};

/** Options de détail, celles qui composent la checklist de saisie. */
export const CAPTURE_OPTION_KEYS: ReadonlyArray<keyof CaptureDetailOptions> = [
  'serviceType',
  'attackType',
  'middleBlockerCall',
  'reversal',
  'blockersCount',
  'zones',
];

export function normalizeCaptureOptions(raw: unknown): CaptureOptions {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_CAPTURE_OPTIONS };
  const source = raw as Record<string, unknown>;
  const details = CAPTURE_OPTION_KEYS.reduce<CaptureDetailOptions>((acc, key) => {
    acc[key] = source[key] === true;
    return acc;
  }, { ...DEFAULT_CAPTURE_OPTIONS });
  // `videoPanel` est actif par défaut : seule une désactivation explicite le
  // masque, pour ne pas perdre le panneau sur les matchs enregistrés avant VS-16.
  return { ...details, videoPanel: source.videoPanel !== false };
}

export function isInputSurface(value: unknown): value is InputSurface {
  return value === 'touch' || value === 'keyboard';
}
